import FlightGroupDaysShiftArrivalModule from './flight-group-days-shift-arrival/flight-group-days-shift-arrival-module';

import FlightGroup from './flight-group-component';
import FlightGroupService from './flight-group-service';

import './flight-group.scss';

const MODULE_NAME = 'app.flight.segment.group';
const module = angular.module(MODULE_NAME, [
        FlightGroupDaysShiftArrivalModule,
    ])
    .directive(FlightGroup.DIRECTIVE_NAME, FlightGroup)
    .service('flightGroupService', FlightGroupService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-segment/flight-group/flight-group-module.js